<template>
  <div>
    <modal
      width="660px"
      speed="fast"
      noOutClose
      maskNoClick
      :show="visible"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      @update:show="closeModal(false)"
      class="mobile-info-modal">
      <p slot="header" class="header">考试信息</p>
      <div slot="content" class="infoContent">
        <p class="infoText">检测到你的设备已在本场考试中已参加过考试，请确认是否使用该账号继续答题</p>
        <div class="infoList">
          <span class="infoItem" v-for="(item, idx) in touristsList" :key="idx">
            <span class="infoLabel">{{ item.label }}:</span>
            <span class="infoValue">{{ item.value }}</span>
          </span>
        </div>
      </div>
      <div slot="footer" class="infoBottom">
        <button
          class="createNewBtn"
          @click="createNewTourists">否，生成新账号</button>
        <button
          class="keepGoBtn"
          @click="goAnswerQues">继续答题</button>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal'
import { userIdType, sexType } from '@/views/touristsPage/constant'
import { get, post } from '@/utils/ajax'
import { getTouristsToken, getTouristsVal, removeTouristsToken, removeTouristsUserId, setTouristsUserId, removeRealTouristsToken } from '@/utils'
import { mapState } from 'vuex'
export default {
  components: {
    Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const isTourists = getTouristsVal()
    const token = getTouristsToken()
    if (token && isTourists) {
      this.getTouristsMsg()
    }
  },
  computed: {
    ...mapState(['user', 'theme', 'site_msg'])
  },
  data() {
    return {
      touristsList: []
    }
  },
  methods: {
    getLabel(list, val) {
      let _label = ''
      list.map((item) => {
        if (item.value === val) {
          _label = item.label
        }
      })
      return _label
    },
    getCityName() {
      return window.localStorage.getItem('TOURISTSCITY') || ''
    },
    async getTouristsMsg() {
      await get(`/home/submitter/query/${this.theme.id}`).then((data) => {
        this.$emit('setTouristsMsg', true)
        const result = []
        const isMobile = this.$route.meta.platform === 'mobile'
        const { submitterInfo, userId } = data
        setTouristsUserId(userId)
        this.$store.dispatch('getTouristsId', userId)
        if (submitterInfo.length > 0) {
          const ignoreList = ['countryId', 'districtId', 'provinceId']
          submitterInfo.map((item) => {
            if (item.checked && !ignoreList.includes(item.bizName)) {
              if (item.inputType === 'TXT' || item.inputType === 'DROP_DOWN_NORMAL') {
                result.push({
                  label: item.showName,
                  value: item.fieldValue
                })
              } else if (item.inputType === 'DROP_DOWN_REGION' && !isMobile) {
                const cityName = this.getCityName()
                if (cityName) {
                  result.push({
                    label: item.showName,
                    value: cityName
                  })
                }
              } else if (item.inputType === 'DROP_DOWN_GENDER') {
                result.push({
                  label: item.showName,
                  value: this.getLabel(sexType, item.fieldValue)
                })
              } else if (item.inputType === 'DROP_DOWN_IDTYPE') {
                result.push({
                  label: item.showName,
                  value: this.getLabel(userIdType, item.fieldValue)
                })
              }
            }
          })
          this.touristsList = result
        }
      })
    },
    createNewTourists() {
      this.$emit('setTouristsMsg', false)
      removeTouristsToken()
      removeRealTouristsToken()
      removeTouristsUserId()
      this.$router.push({ name: 'touristsmsg',
        query: {
          date: new Date().getTime()
        } })
    },
    async goAnswerQues() {
      this.$emit('close', false)
      await post(`/home/sites/params/auto/arrange`, { address: location.origin + '/' + location.href.split('/')[3], exam_id: localStorage.examId, user_id: this.user.id }, { ignoreTourists: true }).then(() => {
        this.$router.push({ name: 'pretest' })
      })
    },
    closeModal(flag) {
      this.$emit('close', flag)
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile-info-modal {
  /deep/ .dialog {
    display: flex;
    flex-direction: column;
    width: calc(100vw - 24px) !important;
    max-width: 560px;
    max-height: calc(100vh - 24px);
    max-height: calc(100dvh - 24px);
    overflow: hidden;
    border-radius: 14px;
  }

  /deep/ .modal-head {
    flex: 0 0 auto;
    padding: 16px 40px;
    font-size: 16px;
    line-height: 22px;
  }

  /deep/ .modal-head .close-icon {
    top: 16px;
    right: 20px;
    line-height: 14px;
  }

  /deep/ .content {
    flex: 1 1 auto;
    min-height: 0;
    padding: 18px 14px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  /deep/ .footer {
    flex: 0 0 auto;
    margin: 0;
    padding: 0 14px 20px;
  }

  .header {
    margin: 0;
    font-size: inherit;
    font-weight: 600;
    line-height: inherit;
    text-align: center;
  }

  .infoText {
    text-align: center;
    font-weight: 400;
    color: #666666;
    margin: 0 0 16px;
    font-size: 13px;
    line-height: 20px;
  }

  .infoList {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-content: start;
    gap: 16px 12px;
    box-sizing: border-box;
    background: #F9F9F9;
    min-height: 150px;
    padding: 16px 22px;
    border-radius: 8px;
  }

  .infoList .infoItem {
    display: flex;
    align-items: baseline;
    width: auto;
    min-width: 0;
    min-height: 22px;
    font-size: 13px;
    line-height: 22px;
  }

  .infoList .infoLabel,
  .infoList .infoValue {
    display: block;
    width: auto;
    min-width: 0;
    margin: 0;
    font-size: inherit;
    line-height: inherit;
    overflow-wrap: anywhere;
  }

  .infoList .infoLabel {
    font-weight: 400;
    color: #999999;
    flex: 0 0 auto;
    max-width: 50%;
    margin-right: 8px;
    text-align: left;
  }

  .infoList .infoValue {
    color: #333333;
    flex: 1;
    font-weight: 600;
  }

  .infoBottom {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin: 0;
  }

  .createNewBtn,
  .keepGoBtn {
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;
    height: 46px;
    padding: 0 4px;
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 44px;
    letter-spacing: 0;
    border-radius: 10px;
    white-space: nowrap;
  }

  .createNewBtn,
  .createNewBtn:hover {
    color: #666666;
    background: #fff;
    border: 1px solid #bfbfbf;
    box-shadow: none;
  }

  .keepGoBtn {
    box-shadow: $buttonShadow;
  }

  .keepGoBtn,
  .keepGoBtn:hover {
    color: #fff;
    border: 1px solid transparent;
    background: var(--mobile-button-background, var(--mobile-theme, #397efd));
  }
}
</style>
